import name from '../router/name'
const adminConfig = [
    {
        menu: '基本业务',
        key: 'applicationManage',
        icon: 'file',
        childen: [
            {
                subMenu: '课程管理',
                routerName: name.course,
                subKey: name.course
            },
            {
                subMenu: '订单管理',
                routerName: name.buy,
                subKey: name.buy
            },
            {
                subMenu: '分销查询',
                routerName: name.seller,
                subKey: name.seller
            },
            {
                subMenu: '提现查询',
                routerName: name.cash,
                subKey: name.cash
            }
        ]
    }
]
export default adminConfig;